import {
  useTableFilter, useTableServerSideFiltering,
  TABLE_CONSTANTS,
  gridSizeMdLg6,
  useTableColumnsSolicitudLiberacion,
  EstadoLiberarVentaENUM,
  formatDateWithTimeAMPM
} from "@/shared";
import { CustomTextArea, CustomTextFieldNoForm, GeneralTable } from "@/shared/components/ui";
import { Alert, Grid, IconButton, Tooltip } from "@mui/material";
import PendingIcon from '@mui/icons-material/Pending';
import { useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useGetSolicitudLineaCorp, usePutSolicitudLineaCorp } from "@/shared/actions/erp";
import { ISolicitudDesbloqueoCorporativo } from "@/shared/interfaces/erp/supervision/solicitud_nueva_linea_corporativo";
import { useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";


const newVentaSolicitudNuevaLineaSchema = yup.object({
  motivo: yup.string().required('Campo Obligatorio')
})

interface IFormPermetirLinea {
  motivo: string;
}

interface TableSolicitudNuveaLineaCorporativoProps {
  enableEditing?: boolean
  showCustomActionBtnSpace?: boolean
  estadoLibreacion?: EstadoLiberarVentaENUM
}
export default function TableSolicitudNuveaLineaCorporativo({

  enableEditing = true,
  showCustomActionBtnSpace = true,
  estadoLibreacion = EstadoLiberarVentaENUM.EN_ESPERA
}: TableSolicitudNuveaLineaCorporativoProps) {

  const [open, setOpen] = useState(false);
  const [dataSolicitud, setDataSolicitud] = useState<ISolicitudDesbloqueoCorporativo | null>(null);

  ///* Hook
  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
  const { pageIndex, pageSize } = pagination;
  const { columnSolicitudNuevaLineaCorporativo } = useTableColumnsSolicitudLiberacion({ estado_solicitud: estadoLibreacion });

  const form = useForm<IFormPermetirLinea>({
    resolver: yupResolver(newVentaSolicitudNuevaLineaSchema)
  });

  ///* Fetch

  const {
    isLoading,
    data: solcitudLineaCorp,
    isRefetching
  } = useGetSolicitudLineaCorp(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false,
      estado_solicitud: estadoLibreacion,
    }
  );

  const {
    mutateAsync: putSolicitudLinea
  } = usePutSolicitudLineaCorp({})

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>
        <Grid item xs={12}>
          <GeneralTable<ISolicitudDesbloqueoCorporativo>
            columns={columnSolicitudNuevaLineaCorporativo}
            data={solcitudLineaCorp?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={solcitudLineaCorp?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // crud
            canDelete={false}
            canEdit={false}
            positionActionsColumn='first'
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}

            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container>
                    <Grid item >
                      <Tooltip placement='top' title='Ver Solicitud'>
                        <IconButton
                          onClick={() => {

                            setOpen(true)
                            setDataSolicitud(value)
                          }}
                        >
                          <PendingIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                  </Grid>
                </>
              )
            }
            }

          />
        </Grid>
      </Grid>

      {
        open && dataSolicitud && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="Permitir nueva línea"
            showConfirmBtn={true}
            onConfirm={form.handleSubmit(async (form) => {


              await putSolicitudLinea({
                id: dataSolicitud.id_solicitud_desbloqueo_coorporativo!,
                data: {
                  motivo: form.motivo,
                  estado_solicitud: EstadoLiberarVentaENUM.APROBADO
                }
              })

              setOpen(false);
              setDataSolicitud(null);

            })}
            confirmVariantBtn={'contained'}
            showRejectBtn={true}
            onReject={form.handleSubmit(async (form) => {


              await putSolicitudLinea({
                id: dataSolicitud.id_solicitud_desbloqueo_coorporativo!,
                data: {
                  motivo: form.motivo,
                  estado_solicitud: EstadoLiberarVentaENUM.CANCELADO
                }
              })

              setOpen(false);
              setDataSolicitud(null);

            })}

            onClose={() => {
              setOpen(false)
            }}
            contentNode={

              <Grid container spacing={3}>

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Fecha de registro'}
                  defaultValue={formatDateWithTimeAMPM(dataSolicitud?.prospecto_corporativo_data.fecha_creacion!)}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Canal de venta'}
                  defaultValue={dataSolicitud?.prospecto_corporativo_data.canal_venta_create}
                  size={gridSizeMdLg6}
                />
                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Asesor'}
                  defaultValue={dataSolicitud?.prospecto_corporativo_data.user_create}
                  size={gridSizeMdLg6}
                />


                <Grid item xs={12}>
                  <Alert severity="success">{`El cliente tiene registrado un prospecto en ${dataSolicitud?.prospecto_corporativo_data.estado_prospecto}`}</Alert>
                </Grid>


                <CustomTextArea
                  label="Motivo"
                  name="motivo"
                  control={form.control}
                  defaultValue={
                    form.getValues('motivo') || ''
                  }
                  error={form.formState.errors.motivo}
                  helperText={
                    form.formState.errors.motivo?.message
                  }
                  required={true}
                />

              </Grid>
            }
          />
        )
      }

    </>
  );

}